<template>
    <div>
        <b-modal id="modal-customer-user" title="User" @ok="onSubmit">
            <template #default>
                <b-form>
                    <b-form-group
                        id="input-group-1"
                        label="Email address:"
                        label-for="input-1"
                        description="We'll never share your email with anyone else."
                    >
                        <b-form-input
                            id="input-1"
                            v-model="userModel.email"
                            type="email"
                            placeholder="Enter email"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-2"
                        label="First Name:"
                        label-for="input-2"
                    >
                        <b-form-input
                            id="input-2"
                            v-model="userModel.first_name"
                            placeholder="Enter First Name"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-last-name"
                        label="Last Name:"
                        label-for="input-last-name"
                    >
                        <b-form-input
                            id="input-last-name"
                            v-model="userModel.last_name"
                            placeholder="Enter Last Name"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="input-group-password"
                        label="Password:"
                        label-for="input-password"
                    >
                        <b-form-input
                            id="input-password"
                            v-model="userModel.password"
                            type="password"
                            required
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </template>
            <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button
                    size="sm"
                    :disabled="loading"
                    variant="success"
                    @click="ok()"
                >
                    <b-spinner
                        v-show="loading"
                        variant="primary"
                        label="Spinning"
                    ></b-spinner>
                    <span v-show="!loading">Submit</span>
                </b-button>
                <b-button size="sm" variant="danger" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>
        <b-button size="sm" class="mr-2" v-b-modal.modal-customer-user
            >Add User</b-button
        >
        <b-table striped hover :items="users" :fields="fields">
            <template #cell(id)="{ item }">
                <b-button
                    size="sm"
                    @click="deleteUser(item.id)"
                    class="mr-2"
                    variant="warning"
                >
                    Delete
                </b-button>
            </template>
        </b-table>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    mixins: [popupMixins],
    data: () => ({
        fields: [{ label: '', key: 'id' }, 'first_name', 'last_name', 'email'],
        userModel: {
            first_name: null,
            last_name: null,
            email: null,
            id: null,
        },
        loading: false,
        settings: {},
    }),
    props: ['customer_id'],
    computed: {
        users() {
            return this.$store.getters['customers/customerUsers']
        },
    },

    async mounted() {
        console.log('Mounting settings')
        await this.$store.dispatch(
            'company/fetchConfiguration',
            'orderReferenceNoSettings'
        )
        console.log('Settings are: ')
        this.settings = this.$store.state.company.settings
    },

    methods: {
        async onSubmit(event) {
            // Destrucuture configuration from company settings
            const { configurations } = this.settings
            const data = configurations[0][0]

            // If configurations are not present, cancel excecution
            if (!data) {
                const message =
                    'Company configuration not set. Please navigate to Order settings to set configuration'
                this.doToast('Error', message, 'danger')

                return
            }

            try {
                event.preventDefault()
                const { customer_id, userModel: data } = this
                this.loading = true
                await this.$store.dispatch('customers/createUser', {
                    customer_id,
                    data,
                })
                this.doToast('User Created', 'Created', 'success')
            } catch (err) {
                console.log('err', err)
                this.doToast('Error Detected', err.message, 'warning')
            } finally {
                this.loading = false
            }
        },
        async deleteUser(user_id) {
            try {
                const title = 'Delete Customer?'
                const message = `Are you sure you want to delete the User?`
                const result = await this.confirmMessage(title, message)
                if (!result) throw new Error('Cancel Delete!')

                const { customer_id } = this
                this.loading = true
                await this.$store.dispatch('customers/deleteUser', {
                    customer_id,
                    user_id,
                })
                this.doToast('User Deleted', 'Deleted', 'success')
            } catch (err) {
                console.log('err', err)
                this.doToast('Error Detected', err.message, 'warning')
            } finally {
                this.loading = false
            }
        },
    },
}
</script>
